import moment from 'moment';

import { MonthItem, YearTabProps } from './interface';

export const getCurrentYearTab = () => {
  const allMonths = [...moment.months()];

  const currentMonths = allMonths.splice(
    allMonths.indexOf(moment().format('MMMM'))
  );
  const currentItems: MonthItem[] = [];
  currentMonths.forEach((currentMonth) =>
    currentItems.push({
      name: currentMonth,
      checked: false,
      number: moment().month(currentMonth).format('MM'),
      abbreviation: moment().month(currentMonth).format('MMM'),
    })
  );

  return {
    year: moment().year(),
    months: currentItems,
  };
};

export const getNextYearTab = () => {
  return {
    year: moment().add(1, 'years').year(),
    months: [...moment.months()].map((currentMonth) => ({
      name: currentMonth,
      checked: false,
      number: moment().month(currentMonth).format('MM'),
      abbreviation: moment().month(currentMonth).format('MMM'),
    })),
  };
};

export const generateDateParam = (
  currentYear: YearTabProps,
  nextYear: YearTabProps
) => {
  const selectedItems: string[] = [];
  currentYear.months.forEach((item) => {
    if (item.checked) {
      selectedItems.push(`${currentYear.year}${item.number}`);
    }
  });

  nextYear.months.forEach((item) => {
    if (item.checked) {
      selectedItems.push(`${nextYear.year}${item.number}`);
    }
  });

  if (selectedItems.length === 0) return '';

  return selectedItems;
};
